import { defineHierarchyChart } from '@rdrive/helper-chart-config';
import { ensureChartUsersTable } from '@/utils/chartUsers';
import { STATUS_HISTORY_CHART, SINGLE_STATUS_LEVEL } from './statusHistoryHierarchy.js';

// Status-history activity by team profile -> team -> user -> status -> single status, for the
// Activity page's StackedHorizontalBarChart (@rdrive/plugin-chart-stacked-bar). Since
// IA_ABSORPTION_PLAN Phase 5 steps 5.2–5.4 a level table on `defineHierarchyChart`
// (@rdrive/helper-chart-config) — the generated queries equal the old hand-written ones
// (tooling/parity/hierarchy-chart/), and every filter value goes through escapeSql (rule 6).
//
// Scoping: none — a user bar's team and a status bar's user arrive as the base's second positional
// contextUpdater argument, so no closure drill state is needed (./statusHistoryHierarchy.js).

const TEAMS = 'JOIN teams t ON sh.createdByTeamId = t.id';

export function useStatusHistoryTeamsChart({ chartName, filterContext, conn }) {
  return defineHierarchyChart({
    chartName,
    filterContext,
    conn,
    ...STATUS_HISTORY_CHART,
    levels: [
      {
        level: 'teamProfile', titleKey: 'teamProfile',
        id: 't.teamProfileId', parentId: 't.teamProfileId', title: 't.teamProfileTitle', joins: [TEAMS],
        orderBy: 't.teamProfileTitle, sort, s.title',
        filter: { joins: [TEAMS], where: [['t.teamProfileId', 'id']] },
      },
      {
        level: 'team', titleKey: 'teams',
        id: 't.id', parentId: 't.teamProfileId', title: 't.name', joins: [TEAMS],
        orderBy: 't.name, sort, s.title',
        filter: { where: [['sh.createdByTeamId', 'id']] },
      },
      // The users table is a Key/Value store and cannot be joined directly; the data query joins the
      // chart_users lookup built from team_users instead (`before`), and falls back to the user id
      {
        level: 'user', titleKey: 'users',
        id: 'sh.createdByUserId', parentId: 'sh.createdByTeamId', title: 'COALESCE(u.displayName, sh.createdByUserId)',
        joins: ['LEFT JOIN chart_users u ON sh.createdByUserId = u.id'],
        groupBy: 'sh.createdByUserId, sh.createdByTeamId, u.displayName, s.title, s.color',
        orderBy: 'title, sort, s.title',
        before: () => ensureChartUsersTable(conn),
        filter: { where: [['sh.createdByUserId', 'id'], ['sh.createdByTeamId', 'parentId']] },
      },
      {
        level: 'status', titleKey: 'status',
        id: 's.id', parentId: 'sh.createdByUserId', title: 's.title',
        groupBy: 's.id, sh.createdByUserId, s.title, s.color, s.sort', orderBy: 's.sort, s.title',
        filter: { where: [['sh.statusId', 'id'], ['sh.createdByUserId', 'parentId']] },
      },
      SINGLE_STATUS_LEVEL,
    ],
  });
}
